<template>
  <div class="personalIntroduction">
    <div class="header">
        <img src="../assets/personalIntroduction/title.png" >
    </div>
    <div class="one">
      <div class="content">
        <img class="left listNum" src="../assets/personalIntroduction/one.png" >
        <div class="center">
            2008年出国创业，<br>经过十多年的打拼，<br>成为了迪拜区块链领军人物和迪拜创业传奇，<br>成为世界虚拟货币论坛主讲嘉宾。<br>
            一个有情怀有使命有10多年成功创业经验的钢铁侠。这个钢铁侠，腾讯新闻、今日头条、光明网、网易财经、搜狐财经、新浪财经、北京晨报等数十家媒体都有过他的报道。
        </div>
        <div class="right">
            <img src="../assets/personalIntroduction/one_right01.png" >
            <p><span>百度搜索廖望</span></p>
        </div>
      </div>
    </div>
    <div class="two">
      <div class="content">
        <img class="left listNum" src="../assets/personalIntroduction/two.png" >
        <div class="right">
            <div class="top">
              <p>廖望（CEO）作为“让天下有更好用的加密货币”</p>
              <p>“用区块链让美元霸权剥削不了中国人”思想的提出者</p>
            </div>
            <div class="center">
              <p>作为用毛泽东思想干区块链的改革行动家</p>
              <p>作为布雷顿森林体系愿景实践者</p>
              <p>作为想用区块链改变世界的疯子</p>
            </div>
            <div class="line"></div>
            <div class="bottom">
              <p>他也是十足的足球爱好者</p>
              <p>一个致力于用科技改变未来的创业者</p>
            </div>
        </div>
      </div>
    </div>
    <div class="three">
      <div class="content">
        <img class="left listNum" src="../assets/personalIntroduction/three.png" >
        <div class="right">
            <div class="top">
              <img src="../assets/personalIntroduction/three01.png" >
              <img src="../assets/personalIntroduction/three02.png" >
              <img src="../assets/personalIntroduction/three03.png" >
            </div>
            <div class="bottom">十多年间，他历经磨难、不断探索，从睡楼梯走道崛起，先后于2009年成立迪拜原子能房产有限公司，投资过数百套房产。2012年廖望通过迪拜著名律师事务所BSA担保交易收购尼日利亚政府国家资产管理局在迪拜的46套房产 ；2013年从尼日力亚国家资产管理局收购迪拜大洋腾挪资产管理有限公司；2017年1月廖望10美金的时候大量买入以太坊，莱特币； 2017年10到12月，廖望大量增持比特币，莱特币，瑞波币；2018年4月成立开曼原子基金有限公司作为原子币的发行主体，成立了原子链项目。</div>
        </div>
      </div>
    </div>
    <div class="four">
        <div class="content">
          <div class="top">
            <img class="img01" src="../assets/personalIntroduction/four.png" >
            <img class="img02" src="../assets/personalIntroduction/common.png" >
          </div>
          <div class="bottom1">
              <p>十年磨一剑，通过艰苦打拼，廖望成为了迪拜华人创业传奇；实现个人财富自由以后心系祖国人民，于2018年踌躇满志，回到祖国，开启了人生中又一次创业传奇：</p><br>
              <p>2018年8月回国后在中国投资成立一系列科技公司；</p><br>
              <p>2018年11月央视主持人李雨霏采访廖望并录制节目《小原子也可以点亮世界》，并获得2018年度新经济领域最具创新力CEO；</p><br>
              <p>2019年10月30日，廖望受邀出席英国前首相布朗可持续发展大讲坛；</p><br>
              <p>2020年1月，应邀出席意大利前总理马泰奥·伦齐先生在北京举办的“战略合作伙伴新春联谊会”晚宴活动；</p><br>
              <p>2020中国经济新锐人物奖获得者；</p><br>
              <p>2020年10月26日，廖望与麦克存储达成战略合作，将斥资一亿元人民币战略投资麦客存储，进军分布式存储（IPFS）领域；</p><br>
              <p>2020年为抗击疫情捐助100万元，发动近300万用户为新冠疫情捐款，用区块链给抗疫贡献赋能；</p><br>
              <p>2021年再次捐助100万元，成立“廖望助学基金”；</p><br>
              <p>2021年8月，原子链公益为河南水灾筹集善款30余万元，CEO廖望亲自带领团队将50余吨物资搬运到专车上发往河南灾区；</p><br>
              <p>2021年8月，廖望通过原子链资本购入12.6万枚Filecoin，近10万枚波卡币，3000枚以太坊及数千万的其它加密货币；</p><br>
              <p>2021年10月21日，廖望参加中国通信委员会区块链专委会主办的“1024区块链活动日”，发表重要言论“世界是你的，也是我的，最后都是玩区块链的”；</p><br>
              <p>2022年10月，廖望被聘为萨尔瓦多驻华大使馆特邀区块链行业顾问；</p><br>
              <p>2023年6月6日，廖望被北京赣州企业商会授予社会责任奖；</p><br>
              <p>2023年9月9日，廖望获聘黑龙江大学校友导师及创业导师；</p><br>
              <p>2023年9月27日，廖望携手北京公益发展促进会，向河北涿州塔照中心小营小学捐赠一所图书馆；</p><br>
              <p>2023年10月2日，廖望受邀参加母校兴国平川中学百年校庆，并成立谢远谱-廖望奖学金。10月3日向50位优秀学子发放奖学金；</p><br>
              <p>2023年11月17日，廖望受央企大有融创邀请，在2024数字消费产业发展高峰论坛上发表题为《数字消费的发展趋势和前景》专题演讲；</p><br>
              <p>2024年5月12日，在首届侨界公益贡献表彰活动中，原子链CEO廖望获授:《侨界公益人物》；</p><br>
              <p>2024年7月30日，原子链CEO，廖望助学金设立人廖望受邀参加了清华大学、北京大学、北京师范大学志愿者关爱农村留守儿童活动。</p><br>
          </div>
          <div class="bottom2">
              <img class="four_01" src="../assets/personalIntroduction/four_01.png">
              <div class="imgs">
                <img src="../assets/personalIntroduction/four_02.png">
                <img src="../assets/personalIntroduction/four_03.png">
              </div>
          </div>
          <div class="line"></div>
          <div class="bottom3">
            <div class="top">
              <div>
                <p>
                  除此之外，廖望担任了：<br>
                  北京赣州企业商会执行会长；<br>
                  阿联酋江西商会执行会长；<br>
                  中国通信工业委员会区块链专委会常委；<br>
                  迪拜原子能房产董事长；<br>
                  原子链创始人，乐唰创始人；<br>
                  萨尔瓦多驻华大使馆特邀区块链行业顾问；<br>
                  黑龙江大学校友导师及创业导师；<br>
                  廖望助学金设立人；<br>
                </p>
              </div>
              <img src="../assets/personalIntroduction/four_04.png" >
            </div>
            <!-- <p class="topP">中国管理科学研究院产业创新研究所客座教授。</p> -->
            <p class="topP">回国后短短三年，廖望又创造出了新的创业传奇。这都要归功于其魔法技能铁人三项的魅力：</p>
            <div class="item">
              <p>(1) 创业已经有13年，13年整合团队经验和管理沉淀。刚开始创业头几年，由于管理上的错误，犯了成百上千万的血泪教训，也因为一些不必要的执着痛失很多关键人才，没有13年管理实战经验的学习，没有13年中犯过的血泪错误，粘合和管理各种人才就不可能有今天的成熟。</p>
              <div class="imgs">
                <img src="../assets/personalIntroduction/four_05.png">
                <img src="../assets/personalIntroduction/four_06.png">
              </div>
            </div>
            <div class="item">
              <p>(2) 爱钻研，在感兴趣的领域会做的很出色，能实现所谓的“不可能”。曾经的学霸，每个学科都考过第一，写诗都写全校第一。篮球场上一阵风，足球场上鸡血哥。大学以1.6米多的身高，蹩脚的普通话，住贫困生宿舍，吓跑了系里几乎所有女同学。现在屌丝逆袭，赢得各国美女芳心，现任女友是波兰国家运动员，实现金发碧眼大长腿的梦想。爱钻研，能解决各种一般人解决不了的问题。举个例子“家里大别墅监控安装的是最新款，有10年安装经验的巴基斯坦师傅搞不定，我用了半个晚上研究，自己搞定。”“车胎坏了，朋友卸载备胎，卸载半天没成功，我研究3分钟，搞定。”自己想要做成的领域，都能成为该领域的佼佼者。</p>
              <div class="imgs">
                <img src="../assets/personalIntroduction/four_07.png">
                <img src="../assets/personalIntroduction/four_08.jpg">
              </div>
            </div>
            <div class="item">
              <p>(3) 国际视野：10多年海外经验，游历各国。交往各国朋友，非常融入国外的文化。英文说的跟普通话一样。极具国际视野。原子币是解决国际间支付自由痛点的，必须要有国际视野。国内ICO不合法，禁止各种加密货币交易，决定了干这个事情必须要在国外，必须要有国际视野。</p>
              <div class="imgs">
                <img src="../assets/personalIntroduction/four_09.jpg">
                <img src="../assets/personalIntroduction/four_10.png">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="five">
        <div class="content">
          <div class="top">
            <img class="img01" src="../assets/personalIntroduction/five.png" >
            <img class="img02" src="../assets/personalIntroduction/common.png" >
          </div>
          <div class="bottom1">
            <div>
              <p>这几项魔法技能中的单项可能很多人都有，但是三项都有，而且充满斗志,世间难寻。</p><br>
              <p>“有志者事竟成”！廖望先生新的创业传奇，大幕已经开启!</p><br>
              <p>未来的路还很长，他坚信：“事在人为，小原子也可以点亮世界”！正如廖望的名句“人就像一颗原子，很微小，但是潜力无限，通过链接释放的能量可以点亮世界”。</p>
            </div>
            <img src="../assets/personalIntroduction/five_01.png" >
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import { enums } from "../../../enum";
export default {
  name: 'personalIntroduction',
  data() {
    return {
      
    };
  },
  mounted() {
   
  },
  methods: {
    
  },
};
</script>
<style scoped>
.personalIntroduction
{
  width: 100%;
  overflow-x: hidden;
  min-height: 100%;
  font-size: 0.2rem;
}
.header img{
  width: 100%;
  height: 5.96rem;
}
/* 1 2*/
.one,.two{
  width: 100%;
  padding: 0.16rem 0;
  height: auto;
  background: linear-gradient(-90deg, #DBE0F4, #EAEDFC, #D9DEF4);
}
.two{
  padding-top: 0;
}
.one .content,.two .content,.three .content
{
  display: flex;
  width: 100%;
  height: auto;
  padding: 0.16rem 0.14rem 0.3rem;
  background: #fff;
}
.listNum{
  margin-right: 0.16rem;
  width: 0.42rem;
  height: 2.2rem;
}
.one .content .center{
  line-height: 0.36rem;
  color: #333E50;
}
.one .content .right{
  text-align: center;
}
.one .content .right img{
  margin-left: 0.23rem;
  width: 3.78rem;
  height: 3.1rem;
}
/* .one .content .right p{
  display: inline-block;
  width: 2.38rem;
  height: 0.26rem;
  line-height: 0.26rem;
  text-align: center;
  background: #333E50;
  color: #FFF;
  letter-spacing: 0.1rem;
} */
.one .content .right p{
  display: inline-block;
  height: 0.28rem;
}
.one .content .right p span{
  padding: 0 0.34rem;
  line-height: 0.28rem; 
  text-align: center;
  background: #333E50;
  color: #FFF;
  letter-spacing: 0.1rem;
}

/* 2 */
.two .top p:nth-child(1){
  margin-bottom: 0.2rem;
  margin-top: 0.16rem;
  display: inline-block;
  width: 5.86rem;
  height: 0.44rem;
  font-size: 0.24rem;
  line-height: 0.44rem;
  text-align: center;
  background: #333E50;
  color: #FFF;
  letter-spacing: 0;
}
.two .top p:nth-child(2){
  display: inline-block;
  width: 5.86rem;
  height: 0.44rem;
  font-size: 0.24rem;
  line-height: 0.44rem;
  text-align: center;
  background: #333E50;
  color: #FFF;
  letter-spacing: 0;
}
.two .line
{
  margin: 0.2rem auto 0;
  width: 5.08rem;
  height: 0.02rem;
  border-bottom: 0.02rem dashed #8397B0;
}
.two .center,.two .bottom{
  margin-top: 0.12rem;
  text-align: center;
}
.two .center p,.two .bottom p{
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.34rem;
}
/* 3 */
.three .content .right 
{
  text-align: center;
}
.three .content .right .top
{
  display: flex;
  margin-bottom: 0.2rem;
}
.three .content .right .top img
{
  width:2.1rem;
  height: 2.1rem;
}
.three .content .right .top img:nth-child(2)
{
  margin: 0 0.12rem;
}
.three .content .bottom
{
  text-align: left;
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.34rem;
}
/* 4 */
.four
{
  padding-top: 0.16rem;
  width: auto;
  height: auto;
  background: #FFF;
  background: linear-gradient(-90deg, #DBE0F4, #EAEDFC, #D9DEF4);
}
.four .content
{
  padding: 0 0.16rem 0.3rem 0.16rem;
  width: 100%;
  height: auto;
  background: #FFF;
}
.four .top
{
  position: relative;
}
.four .top .img01
{
  position: absolute;
  top: 0.16rem;
  left: 0;
  width: 2.06rem;
  height: 0.72rem;
}
.four .top .img02
{
  position: absolute;
  top: 0;
  right: 0.6rem;
  width: 2.28rem;
  height: 0.68rem;
}
.four .bottom1
{
  padding-top: 1.1rem;
}
.four .bottom1 p
{
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.34rem;
}
.four .bottom2
{
  margin-top: 0.28rem;
  display: flex;
  margin-bottom: 0.3rem;
}
.four .bottom2 .imgs
{
  display: flex;
  flex-direction: column;
}
.four .bottom2 .four_01
{
  margin-right: 0.1rem;
  width: 3.22rem;
  height: 4.36rem;
}
.four .bottom2 .imgs img
{
  margin-bottom: 0.1rem;
  width: 3.72rem;
  height: 2.12rem;
}
.four .bottom2 .imgs img:nth-child(2)
{
  margin-bottom: 0;
}
.four .line
{
  width: 100%;
  height: 0.02rem;
  border-bottom: 0.02rem solid #333E50;
}
.bottom3 .top
{
  display: flex;
}
.bottom3 .top div,.bottom3 .top img
{
  flex: 1;
}
.bottom3 .top img
{
  width: 3.8rem;
  height: 2.2rem;
}
.bottom3 .top p
{
  margin-top: 0.48rem;
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.46rem;
}
.bottom3 .topP,.bottom3 .item p
{
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.46rem;
}
.bottom3 .item .imgs
{
  margin-bottom: 0.3rem;
  margin-top: 0.3rem;
  display: flex;
}
.bottom3 .item img
{
  width: 3.48rem;
  height: 2.48rem;
}
.bottom3 .item img:nth-child(1)
{
  margin-right: 0.1rem;
}
/* 5 */
.five
{
  padding-top: 0.16rem;
  width: auto;
  height: auto;
  background: #FFF;
  background: linear-gradient(-90deg, #DBE0F4, #EAEDFC, #D9DEF4);
}
.five .content
{
  padding: 0 0.16rem 0.3rem 0.16rem;
  width: 100%;
  height: auto;
  background: #FFF;
}
.five .top
{
  position: relative;
}
.five .top .img01
{
  position: absolute;
  top: 0.16rem;
  left: 0;
  width: 2.06rem;
  height: 0.72rem;
}
.five .top .img02
{
  position: absolute;
  top: 0;
  right: 0.6rem;
  width: 2.28rem;
  height: 0.68rem;
}
.five .bottom1
{
  padding-top: 1.16rem;
  display: flex;
}
.five .bottom1 p
{
  font-size: 0.2rem;
  color: #333E50;
  line-height: 0.34rem;
}
.five .bottom1 img
{
  width: 1.78rem;
  height: 3.06rem;
}
</style>





// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/personalIntroduction.vue